import { controls,grouped } from "../controls";
const inventory_items = {
label: "Inventory Items",
pageLabel: "Inventory Items",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "inventory_item_code",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Inventory Item Name"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "inventory_item_name",width:"col-sm-4",maxlength:100}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "inventory_item_code",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Inventory Item Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "inventory_item_name",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Unit",star:false}),
...controls.oc({ tab: "general", c: "Unit", placeHolder: "Unit Code", name: "unit_code", isRequired:false,fastpath:"units"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "unit_display"}),
...controls.displayText({ tab: "general", label: "Hsn",star:false}),
...controls.oc({ tab: "general", c: "HSN", placeHolder: "Hsn Code", name: "hsn_code", isRequired:false,fastpath:"hsns"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "hsn_display"}),
...controls.displayText({ tab: "general", label: "Warranty In Months",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "warranty_in_months",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Eol",target: "eol",star:false}),
...controls.magicDate({ tab: "general", name: "eol", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Threshold"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "min_threshold",maxlength:16}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Max Threshold"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "max_threshold",maxlength:16}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Nature Of Use",star:false}),
...controls.oc({ tab: "general", c: "NatureOfUse", placeHolder: "Nature Of Use", name: "nature_of_use_code", isRequired:false,fastpath:"nature_of_uses"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "nature_of_use_display"}),
...controls.displayText({ tab: "general", label: "Min Quantity Requisition",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "min_quantity_requisition",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Service",default:false, name: "is_service" }),
...controls.checkBox({ tab: "general", label: "Is Pm Required",default:false, name: "is_pm_required" }),
...controls.checkBox({ tab: "general", label: "Is Insurence Required",default:false, name: "is_insurence_required" }),
]
,history:{
perPage: 10,
reportHeader: "Inventory Items",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Inventory Item Code",accessor: "inventory_item_code",},
{Header: "Inventory Item Name",accessor: "inventory_item_name",},
{Header: "Unit Id",accessor: "unit_id",},
{Header: "Hsn Id",accessor: "hsn_id",},
{Header: "Warranty In Months",accessor: "warranty_in_months",},
{Header: "Eol",accessor: "eol",type:'date'},
{Header: "Min Threshold",accessor: "min_threshold",},
{Header: "Max Threshold",accessor: "max_threshold",},
{Header: "Nature Of Use Id",accessor: "nature_of_use_id",},
{Header: "Min Quantity Requisition",accessor: "min_quantity_requisition",},
{Header: "Is Service",accessor: "is_service",type:'tick'},
{Header: "Is Pm Required",accessor: "is_pm_required",type:'tick'},
{Header: "Is Insurence Required",accessor: "is_insurence_required",type:'tick'},
]}};
export default inventory_items;